<template>
  <Navbar />
  <div class="register">
    <RegProgressBar :currentStep="2" />
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import Navbar from "../components/Navbar.vue";
import RegProgressBar from "../components/RegProgressBar.vue";

const router = useRouter();

onMounted(() => {
  router.replace("/register-profile");
});
</script>

<style scoped>
.register {
  width: 100%;
  min-height: 100vh;
  background-color: var(--color-primary-bg);
  background: linear-gradient(180deg, #f9f9f9, #baddff);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 16px 24px;
  box-sizing: border-box;
}
</style>
